
import ConfirmBox from "components/shared/VmwareMappingConfirmBox";
import { useState, useEffect, useRef } from "react";
import Breadcrumb from "components/shared/Breadcrumb";
import hisService from "services/admin/masters/hisService";
import Select from "react-select";
import MaterialTable from "material-table";
import { toast } from "react-toastify";
import { getMatrixId } from "utils/matriceHelpers";
import { MAPPING_INPUT_ERROR_TEMPLATE, MAPPING_SELECT_ERROR_TEMPLATE } from "constants/admin/masters/his";
import { ERROR_MESSAGE_UNKNOWN, MSG_RECORD_CREATE, MSG_RECORD_DELETE, MSG_RECORD_UNDO_DELETE, MSG_RECORD_UPDATE } from "constants/common";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@material-ui/core";
const FIXED_OPTIONS = [
  { id: "Y", value: "Y", label: "Y" },
  { id: "N", value: "N", label: "N" },
  { id: "N/A", value: "N/A", label: "N/A" },
];

function ManageHisExtra() {

  const [breamcrumbs, setBreamcrumbs] = useState([
    { title: "HIS Masters Mapping", url: "/admin/master/his/" },
    { title: "Manage Mapping" },
  ]);

  const serviceObj = new hisService();

  const accordionRef = useRef(null);

  const [formExpanded, setFormExpanded] = useState(false);
  const [combineKeyList, setCombineKeyList] = useState([]);
  const [mappingList, setMappingList] = useState([{}]);
  const [solutionTypeList, setSolutionTypeList] = useState([]);
  const [vsphereVersionList, setVsphereVersionList] = useState([]);
  const [vmwareVCenterList, setVmwareVcenterList] = useState([]);
  const [vsanVersionList, setVsanVersionList] = useState([]);
  const [vcfVersionList, setVcfVersionList] = useState([]);
  const [softwareVersionList, setSoftwareVersionList] = useState([]);

  const [selectedCombineKeys, setSelectedCombineKeys] = useState([]);
  const [vsphereVersion, setVsphereVersion] = useState(null);
  const [vmwareVcenter, setVmwareVcenter] = useState(null);
  const [vsanVersion, setVsanVersion] = useState(null);
  const [vcfVersion, setVcfVersion] = useState(null);
  const [additionalVcfUrl, setAdditionalVcfUrl] = useState("");
  const [vmwareInteropUrl, setVmwareInteropUrl] = useState("");
  const [hciModelName, setHciModelName] = useState("");
  const [vsanType, setVsanType] = useState("");
  const [computeNode, setComputeNode] = useState("");
  const [managementNode, setManagementNode] = useState("");
  const [softwareVersion, setSoftwareVersion] = useState(null);
  const [satadomBoot, setSatadomboot] = useState(null);
  const [localDiskBoot, setLocalDiskBoot] = useState(null);
  const [localDiskM2, setLocalDiskM2] = useState(null);
  const [notes, setNotes] = useState("");
  const [releasenotes, setReleaseNotes] = useState("");

  const [combineKeyError, setCombineKeyError] = useState("");
  const [vsphereVersionError, setVsphereVersionError] = useState("");
  const [vcenterError, setVCenterError] = useState("");
  const [vsanVersionError, setVsanVersionError] = useState("");
  const [vcfVersionError, setVcfVersionError] = useState("");
  const [vmwareInteropUrlError, setVmwareInteropUrlError] = useState("");
  const [hciModelNameError, setHciModelNameError] = useState("");
  const [vsanTypeError, setVsanTypeError] = useState("");
  const [computeNodeError, setComputeNodeError] = useState("");
  const [managementNodeError, setManagementNodeError] = useState("");
  const [softwareVersionError, setSoftwareVersionError] = useState(null);
  const [satadomBootError, setSatadomBootError] = useState("");
  const [fcdaBoot, setFcdaBoot] = useState("");
  const [fcdaBootError, setFcdaBootError] = useState("");
  const [sanBoot, setSanBoot] = useState("");
  const [sanBootError, setSanBootError] = useState("");
  const [localDiskBootError, setLocalDiskBootError] = useState("");
  const [localDiskM2Error, setLoclDiskM2Error] = useState("");
  const [notesError, setNotesError] = useState("");
  const [releaseNotesError, setReleaseNotesError] = useState("");
  const [isFormTouched, setIsFormTouched] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [itemToBeEdited, setItemToBeEdited] = useState(null);
  const [isDeleteConfirmationShown, setIsDeleteConfirmationShown] = useState(false);
  const [isRestoreConfirmationShown, setIsRestoreConfirmationShown] = useState(false);
  const [deleteConfirmationMessage, setDeleteConfirmationMessage] = useState("");
  const [restoreConfirmationMessage, setRestoreConfirmationMessage] = useState("");
  const [itemToBeDeletedOrRestored, setItemToBeDeletedOrRestored] = useState(null);
  const [buildList, setBuildList] = useState([]);
  const [buildError, setBuildError] = useState("");
  const [selectedBuild, setSelectedBuild] = useState(null);
  const Id = getMatrixId(window.location.pathname);

  useEffect(() => getMappingData(), []);

  useEffect(() => {
    // re-validate form upon field value change if form is touched
    if (isFormTouched) {
      validateMappingForm();
    }
  }, [selectedCombineKeys]);
    /*
    selectedCombineKeys, solutionType, vsphereVersion, vmwareVcenter, vsanVersion,
    vcfVersion, additionalVcfUrl, vmwareInteropUrl, hciModelName, vsanType, computeNode,
    managementNode, softwareVersion, satadomBoot, localDiskBoot, localDiskM2, zipComponent,
    zipFileName, notes, fcdaBoot, releasenotes
    */


  useEffect(() => {
    // populate details of item to be edited
    if (isEditMode) {
      populateItemDetailsToEdit();
    }
  }, [itemToBeEdited?.record_details?.id]);

  const getMappingData = () => {
    serviceObj.getAllInitialData(Id)
      .then((response) => {
        setMappingList(response?.his_extra_mapping_list);
        extractAndSetCombineKeys(response?.his_combine_keys);
        const vsphereVersionList = extractList(response?.vmware_vsphere_version_drop_list);
        const vcenterList = extractList(response?.vmware_vcenter_drop_list);
        const vsanVersionList = extractList(response?.vmware_vsan_version_drop_list);
        const vcfVersionList = extractList(response?.vmware_vcf_version_drop_list);
        const softwareVersions = extractList(response?.management_software_version_drop_list);
        extractAndSetBuild(response?.build_number_drop_list);
        setSolutionTypeList(solutionTypeList);
        setVsphereVersionList(vsphereVersionList);
        setVmwareVcenterList(vcenterList);
        setVsanVersionList(vsanVersionList);
        setVcfVersionList(vcfVersionList);
        setSoftwareVersionList(softwareVersions);
      })
      .catch((error) => {
        toast.error(ERROR_MESSAGE_UNKNOWN);
      });
  };
  // setting service pack
  const extractAndSetBuild = (dataList) => {
    const buildList = dataList?.map((item) => ({
      id: item?.id,
      value: item?.name,
      label: item?.name,
      disabled: item?.disabled
    }));
    setBuildList(buildList);
  };
  // setting Combine keys
  const extractAndSetCombineKeys = (dataList) => {
    const combineKeyList = dataList?.map((item) => ({
      id: item?.id,
      value: item?.combine_key,
      label: item?.combine_key,
      disabled: item?.disabled
    }));
    setCombineKeyList(combineKeyList);
  };

  const extractList = (dataList) => (
    dataList?.map((item) => ({
      id: item?.id,
      value: item?.name,
      label: item?.name,
      disabled: item?.disabled
    }))
  );

  // reset form values, error messages, form state, edit mode, target edit item
  const resetForm = () => {
    resetFormValues();
    resetErrorMessages();
    setIsFormTouched(false);
    setIsEditMode(false);
    setItemToBeEdited(null);
  };

  // append offending field name in error message
  const getSelectErrorMessageFor = (fieldName) => {
    return MAPPING_SELECT_ERROR_TEMPLATE?.replace("_FIELD_NAME_", fieldName);
  };

  // append offending field name in error message
  const getInputErrorMessageFor = (fieldName) => {
    return MAPPING_INPUT_ERROR_TEMPLATE?.replace("_FIELD_NAME_", fieldName);
  };

  // validate fields and set or reset error message
  const validateMappingForm = () => {
    let isFormValid = true;
    if (!selectedCombineKeys?.length) {
      setCombineKeyError(getSelectErrorMessageFor("Combine Key"));
      isFormValid = false;
    } else {
      setCombineKeyError("");
    }

   

    // if (!vsphereVersion?.id) {
    //   setVsphereVersionError(getSelectErrorMessageFor("VMware vSphere Version"));
    //   isFormValid = false;
    // } else {
    //   setVsphereVersionError("");
    // }

    // if (!vmwareVcenter?.id) {
    //   setVCenterError(getSelectErrorMessageFor("VMware vCenter"));
    //   isFormValid = false;
    // } else {
    //   setVCenterError("");
    // }

    // if (!vsanVersion?.id) {
    //   setVsanVersionError(getSelectErrorMessageFor("VMware vSAN Version"));
    //   isFormValid = false;
    // } else {
    //   setVsanVersionError("");
    // }

    // if (!vcfVersion?.id) {
    //   setVcfVersionError(getSelectErrorMessageFor("VMware VCF Version"));
    //   isFormValid = false;
    // } else {
    //   setVcfVersionError("");
    // }

    // if (!vsanType) {
    //   setVsanTypeError(getInputErrorMessageFor("vSAN Type"));
    //   isFormValid = false;
    // } else {
    //   setVsanTypeError("");
    // }

    // if (!computeNode) {
    //   setComputeNodeError(getInputErrorMessageFor("Compute Node"));
    //   isFormValid = false;
    // } else {
    //   setComputeNodeError("");
    // }

    // if (!managementNode) {
    //   setManagementNodeError(getInputErrorMessageFor("Management Node"));
    //   isFormValid = false;
    // } else {
    //   setManagementNodeError("");
    // }

    // if (!softwareVersion) {
    //   setSoftwareVersionError(getSelectErrorMessageFor("Management Software Version"));
    //   isFormValid = false;
    // } else {
    //   setSoftwareVersionError("");
    // }

    // if (!satadomBoot) {
    //   setSatadomBootError(getInputErrorMessageFor("SATADOM Boot"));
    //   isFormValid = false;
    // } else {
    //   setSatadomBootError("");
    // }

    // if (!localDiskBoot) {
    //   setLocalDiskBootError(getInputErrorMessageFor("Local Disk Boot"));
    //   isFormValid = false;
    // } else {
    //   setLocalDiskBootError("");
    // }

    // if (!localDiskM2) {
    //   setLoclDiskM2Error(getInputErrorMessageFor("Local Disk Boot - M.2"));
    //   isFormValid = false;
    // } else {
    //   setLoclDiskM2Error("");
    // }

    return isFormValid;
  };

  // reset field values
  const resetFormValues = () => {
    setSelectedCombineKeys([]);
    setSanBoot("");
    setSelectedCombineKeys(null);
    setVsphereVersion(null);
    setVmwareVcenter(null);
    setVsanVersion(null);
    setVcfVersion(null);
    setAdditionalVcfUrl("");
    setVmwareInteropUrl("");
    setHciModelName("");
    setVsanType("");
    setComputeNode("");
    setManagementNode("");
    setSoftwareVersion(null);
    setSatadomboot(null);
    setLocalDiskBoot("");
    setLocalDiskM2("");
    // setZipComponent("");
    // setZipFileName("");
    setNotes("");
    setReleaseNotes("");
    setFcdaBoot("");
    setSelectedBuild(null)
  };
  

  // reset error messages
  const resetErrorMessages = () => {
    setCombineKeyError("");
    setVsphereVersionError("");
    setVCenterError("");
    setVsanVersionError("");
    setVcfVersionError("");
    setVmwareInteropUrlError("");
    setHciModelNameError("");
    setVsanTypeError("");
    setComputeNodeError("");
    setManagementNodeError("");
    setSoftwareVersionError("");
    setSatadomBootError("");
    setLocalDiskBootError("");
    setLoclDiskM2Error("");
    setNotesError("");
    setSanBootError("");
    setFcdaBootError("");
    setSanBootError("");
    setBuildError("")
  };

  // api call for adding new mapping
  const addMapping = (e) => {
    e.preventDefault();
    setIsFormTouched(true);
    const isFormValid = validateMappingForm();

    // call POST api if form is valid
    if (isFormValid) {

      let payload = {
        vmware_vsphere_version_id: vsphereVersion?.id,
        vmware_vcenter_id: vmwareVcenter?.id,
        vmware_vsan_version_id: vsanVersion?.id,
        vmware_vcf_version_id: vcfVersion?.id,
        management_software_version_id: softwareVersion?.id,
        url_to_vmware_interoperability: vmwareInteropUrl,
        vsan_type: vsanType,
        compute_node: computeNode,
        management_node: managementNode,
        satadom_boot: satadomBoot?.id,
        local_disk_boot: localDiskBoot?.id,
        local_disk_boot_m2: localDiskM2?.id,
        his_combine_keys: selectedCombineKeys?.map(item => item?.id),
        notes: notes,
        release_notes: releasenotes,
        san_boot: sanBoot?.id,
        fc_direct_attach_boot: fcdaBoot?.id,
        build_number_id: selectedBuild?.id
      }
      serviceObj.createExtraMapping(payload).then((response) => {
        toast.success(MSG_RECORD_CREATE);
        getMappingData();
        resetForm();
        setFormExpanded(false);
      });
    }
  };

  // process target item for editing
  const populateItemDetailsToEdit = () => {
    const combineKeysToEdit = itemToBeEdited?.his_combine_keys?.map((item) => ({
      id: item?.id,
      value: item?.combine_key,
      label: item?.combine_key,
      disabled: item?.disabled
    }));
   const buildNumber = {
      id: itemToBeEdited?.record_details?.build_number_id,
      value: itemToBeEdited?.record_details?.build_number,
      label: itemToBeEdited?.record_details?.build_number
   }
    const vsphereVersionToEdit = {
      id: itemToBeEdited?.record_details?.vmware_vsphere_version_id,
      value: itemToBeEdited?.record_details?.vmware_vsphere_version,
      label: itemToBeEdited?.record_details?.vmware_vsphere_version
    };
    const vcenterToEdit = {
      id: itemToBeEdited?.record_details?.vmware_vcenter_id,
      value: itemToBeEdited?.record_details?.vmware_vcenter,
      label: itemToBeEdited?.record_details?.vmware_vcenter
    };
    const vsanVersionToEdit = {
      id: itemToBeEdited?.record_details?.vmware_vsan_version_id,
      value: itemToBeEdited?.record_details?.vmware_vsan_version,
      label: itemToBeEdited?.record_details?.vmware_vsan_version
    };
    const vcfVersionToEdit = {
      id: itemToBeEdited?.record_details?.vmware_vcf_version_id,
      value: itemToBeEdited?.record_details?.vmware_vcf_version,
      label: itemToBeEdited?.record_details?.vmware_vcf_version
    };
    const softwareVersionToEdit = {
      id: itemToBeEdited?.record_details?.management_software_version_id,
      value: itemToBeEdited?.record_details?.management_software_version,
      label: itemToBeEdited?.record_details?.management_software_version
    };
    const satadomBoot = {
      id: itemToBeEdited?.record_details?.satadom_boot,
      value: itemToBeEdited?.record_details?.satadom_boot,
      label: itemToBeEdited?.record_details?.satadom_boot
    };
    const localDiskBoot = {
      id: itemToBeEdited?.record_details?.local_disk_boot,
      value: itemToBeEdited?.record_details?.local_disk_boot,
      label: itemToBeEdited?.record_details?.local_disk_boot
    };
    const localDiskM2 = {
      id: itemToBeEdited?.record_details?.local_disk_boot_m2,
      value: itemToBeEdited?.record_details?.local_disk_boot_m2,
      label: itemToBeEdited?.record_details?.local_disk_boot_m2
    };
    const fcdirectAttachBoot = {
      id: itemToBeEdited?.record_details?.fc_direct_attach_boot,
      value: itemToBeEdited?.record_details?.fc_direct_attach_boot,
      label: itemToBeEdited?.record_details?.fc_direct_attach_boot
    }
    const sanBoot = {
      id: itemToBeEdited?.record_details?.san_boot,
      value: itemToBeEdited?.record_details?.san_boot,
      label: itemToBeEdited?.record_details?.san_boot
    };
    setSanBoot(sanBoot);
    setFcdaBoot(fcdirectAttachBoot);
    setSelectedCombineKeys(combineKeysToEdit);
    setVsphereVersion(vsphereVersionToEdit);
    setVmwareVcenter(vcenterToEdit);
    setVsanVersion(vsanVersionToEdit);
    setVcfVersion(vcfVersionToEdit);
    setAdditionalVcfUrl(itemToBeEdited?.record_details?.additional_vmware_vcf_url);
    setVmwareInteropUrl(itemToBeEdited?.record_details?.url_to_vmware_interoperability);
    setHciModelName(itemToBeEdited?.record_details?.hci_model_name);
    setVsanType(itemToBeEdited?.record_details?.vsan_type);
    setComputeNode(itemToBeEdited?.record_details?.compute_node);
    setManagementNode(itemToBeEdited?.record_details?.management_node);
    setSoftwareVersion(softwareVersionToEdit);
    setSatadomboot(satadomBoot);
    setLocalDiskBoot(localDiskBoot);
    setLocalDiskM2(localDiskM2);
    setSelectedBuild(buildNumber);
    setComputeNode(itemToBeEdited?.record_details?.compute_node);
    setManagementNode(itemToBeEdited?.record_details?.management_node);
    setNotes(itemToBeEdited?.record_details?.notes);
    setReleaseNotes(itemToBeEdited?.record_details?.release_notes)
  };

  // fetch details of item to be edited
  const editMapping = (data) => {
    setIsEditMode(true);
    // // fetch details of item to edit
    serviceObj.getExtraMappingDetails(data?.id).then((response) => {
      setFormExpanded(true);
      setItemToBeEdited(response);
      accordionRef?.current?.scrollIntoView();
    })
      .catch(error => toast.error(ERROR_MESSAGE_UNKNOWN));
  };

  // update 
  const updateMappingById = (e) => {
    e.preventDefault();
    setIsFormTouched(true);
    const isFormValid = validateMappingForm();
    if (isFormValid) {
     const payload = {
        vmware_vsphere_version_id: vsphereVersion?.id,
        vmware_vcenter_id: vmwareVcenter?.id,
        vmware_vsan_version_id: vsanVersion?.id,
        vmware_vcf_version_id: vcfVersion?.id,
        management_software_version_id: softwareVersion?.id,
        additional_vmware_vcf_url: additionalVcfUrl,
        url_to_vmware_interoperability: vmwareInteropUrl,
        hci_model_name: hciModelName,
        vsan_type: vsanType,
        compute_node: computeNode,
        management_node: managementNode,
        satadom_boot: satadomBoot?.id,
        local_disk_boot: localDiskBoot?.id,
        local_disk_boot_m2: localDiskM2?.id,
        notes: notes,
        his_combine_keys: selectedCombineKeys?.map(item => item?.id),
        release_notes: releasenotes,
        san_boot: sanBoot?.id,
        fc_direct_attach_boot: fcdaBoot?.id,
        build_number_id: selectedBuild?.id
      };
      const targetItemId = itemToBeEdited?.record_details?.id;
      serviceObj.updateExtraMappingById(targetItemId, payload).then((response) => {
        toast.success(MSG_RECORD_UPDATE);
        getMappingData();
        resetForm();
      })
        .catch(error => toast.error(ERROR_MESSAGE_UNKNOWN)
        );
    }
  };

  // delete or restore mapping
  const deleteOrRestoreMappingById = () => {
    const { id, is_deleted } = itemToBeDeletedOrRestored;
    serviceObj.deleteExtraMappingById(id)
      .then((response) => {
        // show deleted or restored message based on is_deleted property
        if (is_deleted) {
          toast.success(MSG_RECORD_UNDO_DELETE);
          setIsRestoreConfirmationShown(false);
          setRestoreConfirmationMessage("")
        } else {
          toast.success(MSG_RECORD_DELETE);
          setIsDeleteConfirmationShown(false)
          setDeleteConfirmationMessage("");
        }
        resetForm();
        setItemToBeDeletedOrRestored(null);
      })
      .catch((error) => {
        toast.error(ERROR_MESSAGE_UNKNOWN);
        setIsDeleteConfirmationShown(false)
        setDeleteConfirmationMessage("");
        setItemToBeDeletedOrRestored(null);
      })
      .finally(() => getMappingData());
  };

  // show delete warning confirmation popup
  const deleteMappingHandler = (rowData) => {
    setIsDeleteConfirmationShown(true);
    setItemToBeDeletedOrRestored(rowData);
    setDeleteConfirmationMessage(`Are you sure you want to remove ${rowData?.vmware_vsphere_version} with Combine Key ${rowData?.his_combine_key}?`)
  };

  // show restore warning confirmation popup
  const restoreMappingHandler = (rowData) => {
    setIsRestoreConfirmationShown(true);
    setItemToBeDeletedOrRestored(rowData);
    setRestoreConfirmationMessage(`Are you sure you want to restore ${rowData?.vmware_solution_type} with Combine Key ${rowData?.his_combine_key}?`);
  };

  // hide confirmation message and reset target item
  const cancelDeleteItem = () => {
    setIsDeleteConfirmationShown(false);
    setItemToBeDeletedOrRestored(null);
  };

  // hide confirmation message and reset target item
  const cancelRestoreItem = () => {
    setIsRestoreConfirmationShown(false);
    setItemToBeDeletedOrRestored(null);
    setRestoreConfirmationMessage("")
  };

  // wrap url when it is very long
  const urlRenderer = (url) => (
    <div style={{ width: 248, wordBreak: 'break-word' }}>
      {url}
    </div>
  );

  return (
    <div className="form-wrap mt-3">
      <Breadcrumb data={breamcrumbs} disableEditTitle={true} />
      {isDeleteConfirmationShown &&
        <ConfirmBox
          actionHandler={deleteOrRestoreMappingById}
          handleSubmit={deleteOrRestoreMappingById}
          cancelDeleteItem={cancelDeleteItem}
        >
          {deleteConfirmationMessage}
        </ConfirmBox>
      }
      {isRestoreConfirmationShown &&
        <ConfirmBox
          actionHandler={deleteOrRestoreMappingById}
          handleSubmit={deleteOrRestoreMappingById}
          cancelDeleteItem={cancelRestoreItem}
        >
          {restoreConfirmationMessage}
        </ConfirmBox>
      }
      <div className="form-group 1">
        <div style={{ marginBottom: 20 }}>
          <Accordion expanded={formExpanded} onChange={(e, expanded) => setFormExpanded(expanded)}>
            <AccordionSummary
              aria-controls="panel1-content"
              id="panel-header"
              ref={accordionRef}
            >
              <Typography component="h2">
                {isEditMode ? "Edit Mapping" : "Add Mapping"}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <form className="w-100">
                <div className="d-flex">
                  {/* Combine key */}
                  <div className="form-group col-sm-6">
                    <label htmlFor={""} className="mr-sm-2 mt-2"><b>HIS Combine Key</b></label>
                    {/* add multi select dropdown */}
                    <Select
                      isMulti
                      name="Combine Key"
                      options={combineKeyList}
                      classNamePrefix="select"
                      onChange={selectedKeys => setSelectedCombineKeys(selectedKeys)}
                      value={selectedCombineKeys}
                      isOptionDisabled={option => option.disabled}
                    />
                    {
                      combineKeyError
                      &&
                      <div className="col-sm-10 mb-2 text-danger">{combineKeyError}</div>
                    }
                  </div>
                   {/* build */}
                  <div className="form-group col-sm-6">
                    <label htmlFor={"servicePack"} className="mr-sm-2"><b>Build Number</b></label>
                    <Select
                      name="servicePack"
                      id="servicePack"
                      options={buildList}
                      classNamePrefix="select"
                      onChange={selectedKeys => setSelectedBuild(selectedKeys)}
                      value={selectedBuild}
                      isOptionDisabled={option => option.disabled}
                      disabled={isEditMode}
                    />
                    {buildError
                      &&
                      <div className="col-sm-10 mb-2 text-danger">{buildError}</div>
                    }
                  </div>
                 
                </div>
                <div className="d-flex">
                  {/* VMware vSphere Version */}
                  <div className="form-group col-sm-6">
                    <label htmlFor={"vmwareVSpere"} className="mr-sm-2"><b>VMware vSphere Version</b></label>
                    <Select
                      name="extra"
                      options={vsphereVersionList}
                      classNamePrefix="select"
                      onChange={selectedId => setVsphereVersion(selectedId)}
                      value={vsphereVersion}
                      isOptionDisabled={option => option.disabled}
                      isDisabled={false}
                    />
                    {vsphereVersionError
                      &&
                      <div className="col-sm-10 mb-2 text-danger">{vsphereVersionError}</div>
                    }
                  </div>
                  {/* VMware vCenter */}
                  <div className="form-group col-sm-6">
                    <label htmlFor={"vmwareVCenter"} className="mr-sm-2"><b>VMware vCenter</b></label>
                    <Select
                      name="vmwareVCenter"
                      options={vmwareVCenterList}
                      classNamePrefix="select"
                      onChange={selectedId => setVmwareVcenter(selectedId)}
                      value={vmwareVcenter}
                      isOptionDisabled={option => option.disabled}
                      isDisabled={false}
                    />
                    {vcenterError
                      &&
                      <div className="col-sm-10 mb-2 text-danger">{vcenterError}</div>
                    }
                  </div>
                </div>
                <div className="d-flex">
                  {/* VMware vSAN Version */}
                  <div className="form-group col-sm-6">
                    <label htmlFor={"vmwareVSanVersion"} className="mr-sm-2"><b>VMware vSAN Version</b></label>
                    <Select
                      name="vmwareVCenter"
                      options={vsanVersionList}
                      classNamePrefix="select"
                      onChange={selectedId => setVsanVersion(selectedId)}
                      value={vsanVersion}
                      isOptionDisabled={option => option.disabled}
                      isDisabled={false}
                    />
                    {vsanVersionError
                      &&
                      <div className="col-sm-10 mb-2 text-danger">{vsanVersionError}</div>
                    }
                  </div>
                  {/* VMware VCF Version */}
                  <div className="form-group col-sm-6">
                    <label htmlFor={"vmwareVcfVersion"} className="mr-sm-2"><b>VMware VCF Version</b></label>
                    <Select
                      name="vmwareVcfVersion"
                      options={vcfVersionList}
                      classNamePrefix="select"
                      onChange={selectedId => setVcfVersion(selectedId)}
                      value={vcfVersion}
                      isOptionDisabled={option => option.disabled}
                      isDisabled={false}
                    />
                    {vcfVersionError
                      &&
                      <div className="col-sm-10 mb-2 text-danger">{vcfVersionError}</div>
                    }
                  </div>
                </div>
                <div className="d-flex">
                 
          
                  {/* URL to VMware Interoperability */}
                  <div className="form-group col-sm-6">
                    <label htmlFor={"vmwareInteropUrl"} className="mr-sm-2"><b>URL to VMware Interoperability</b></label>
                    <input type="text"
                      id="vmwareInteropUrl"
                      className="form-control"
                      name="vmwareInteropUrl"
                      value={vmwareInteropUrl}
                      onChange={(e) => setVmwareInteropUrl(e.target.value)}
                      placeholder="Enter URL to VMware Interoperability"
                    />
                    {vmwareInteropUrlError
                      &&
                      <div className="col-sm-10 mb-2 text-danger">{vmwareInteropUrlError}</div>
                    }
                  </div>
                </div>
                <div className="d-flex">
                  {/* HCI Model Name */}
                  <div className="form-group col-sm-6">
                    <label htmlFor={"hciModelName"} className="mr-sm-2"><b>HCI Model Name</b></label>
                    <input type="text"
                      id="hciModelName"
                      className="form-control"
                      maxLength="60"
                      name="hciModelName"
                      value={hciModelName}
                      onChange={(e) => setHciModelName(e.target.value)}
                      placeholder="Enter HCI Model Name"
                    />
                    {hciModelNameError
                      &&
                      <div className="col-sm-10 mb-2 text-danger">{hciModelNameError}</div>
                    }
                  </div>
                  {/* vSAN Type */}
                  <div className="form-group col-sm-6">
                    <label htmlFor={"vSanType"} className="mr-sm-2"><b>vSAN Type</b></label>
                    <input type="text"
                      id="vSanType"
                      className="form-control"
                      maxLength="60"
                      name="vSanType"
                      value={vsanType}
                      onChange={(e) => setVsanType(e.target.value)}
                      placeholder="Enter vSAN Type"
                    />
                    {vsanTypeError
                      &&
                      <div className="col-sm-10 mb-2 text-danger">{vsanTypeError}</div>
                    }
                  </div>
                </div>
                <div className="d-flex">
                  {/* Compute Node */}
                  <div className="form-group col-sm-6">
                    <label htmlFor={"computeNode"} className="mr-sm-2"><b>Compute Node</b></label>
                    <input type="text"
                      id="vSanType"
                      className="form-control"
                      maxLength="60"
                      name="computeNode"
                      value={computeNode}
                      onChange={(e) => setComputeNode(e.target.value)}
                      placeholder="Enter Compute Node"
                    />
                    {computeNodeError
                      &&
                      <div className="col-sm-10 mb-2 text-danger">{computeNodeError}</div>
                    }
                  </div>
                  {/* Management Node */}
                  <div className="form-group col-sm-6">
                    <label htmlFor={"managementNode"} className="mr-sm-2"><b>Management Node</b></label>
                    <input type="text"
                      id="managementNode"
                      className="form-control"
                      maxLength="60"
                      name="managementNode"
                      value={managementNode}
                      onChange={(e) => setManagementNode(e.target.value)}
                      placeholder="Enter Management Node"
                    />
                    {managementNodeError
                      &&
                      <div className="col-sm-10 mb-2 text-danger">{managementNodeError}</div>
                    }
                  </div>
                </div>
                <div className="d-flex">
                  {/* Management Software Version */}
                  <div className="form-group col-sm-6">
                    <label htmlFor={"softwareVersion"} className="mr-sm-2"><b>Management Software Version</b></label>
                    <Select
                      name="softwareVersion"
                      options={softwareVersionList}
                      classNamePrefix="select"
                      onChange={selectedId => setSoftwareVersion(selectedId)}
                      value={softwareVersion}
                      isOptionDisabled={option => option.disabled}
                      isDisabled={false}
                    />
                    {softwareVersionError
                      &&
                      <div className="col-sm-10 mb-2 text-danger">{softwareVersionError}</div>
                    }
                  </div>
                  {/* SATADOM Boot */}
                  <div className="form-group col-sm-6">
                    <label htmlFor={"satadomBoot"} className="mr-sm-2"><b>SATADOM Boot</b></label>
                    <Select
                      name="satadomBoot"
                      options={FIXED_OPTIONS}
                      classNamePrefix="select"
                      onChange={selection => setSatadomboot(selection)}
                      value={satadomBoot}
                      isOptionDisabled={option => option.disabled}
                    />
                    {satadomBootError
                      &&
                      <div className="col-sm-10 mb-2 text-danger">{satadomBootError}</div>
                    }
                  </div>
                </div>
                <div className="d-flex">
                  {/* Local Disk Boot */}
                  <div className="form-group col-sm-6">
                    <label htmlFor={"localDiskBoot"} className="mr-sm-2"><b>Local Disk Boot</b></label>
                    <Select
                      name="localDiskBoot"
                      options={FIXED_OPTIONS}
                      classNamePrefix="select"
                      onChange={selection => setLocalDiskBoot(selection)}
                      value={localDiskBoot}
                      isOptionDisabled={option => option.disabled}
                    />
                    {localDiskBootError
                      &&
                      <div className="col-sm-10 mb-2 text-danger">{localDiskBootError}</div>
                    }
                  </div>
                  {/* Local Disk Boot - M.2 */}
                  <div className="form-group col-sm-6">
                    <label htmlFor={"localDiskBootM2"} className="mr-sm-2"><b>Local Disk Boot - M.2</b></label>
                    <Select
                      name="localDiskBootM2"
                      options={FIXED_OPTIONS}
                      classNamePrefix="select"
                      onChange={selection => setLocalDiskM2(selection)}
                      value={localDiskM2}
                      isOptionDisabled={option => option.disabled}
                    />
                    {localDiskM2Error
                      &&
                      <div className="col-sm-10 mb-2 text-danger">{localDiskM2Error}</div>
                    }
                  </div>
                </div>
                <div className="d-flex">
                  {/* FC Direct Attach Boot */}
                  <div className="form-group col-sm-6">
                    <label htmlFor={"mainMediaKit"} className="mr-sm-2"><b>FC Direct Attach Boot</b></label>
                    <Select
                      name="fcdaBoot"
                      options={FIXED_OPTIONS}
                      classNamePrefix="select"
                      onChange={selection => setFcdaBoot(selection)}
                      value={fcdaBoot}
                      isOptionDisabled={option => option.disabled}
                    />
                    {fcdaBootError
                      &&
                      <div className="col-sm-10 mb-2 text-danger">{fcdaBootError}</div>
                    }
                  </div>
                  {/* SAN Boot */}
                  <div className="form-group col-sm-6">
                    <label htmlFor={"mainMediaKit"} className="mr-sm-2"><b>SAN Boot</b></label>
                     <Select
                      name="sanBoot"
                      options={FIXED_OPTIONS}
                      classNamePrefix="select"
                      onChange={selection => setSanBoot(selection)}
                      value={sanBoot}
                      isOptionDisabled={option => option.disabled}
                    />
                    {notesError
                      &&
                      <div className="col-sm-10 mb-2 text-danger">{sanBootError}</div>
                    }
                  </div>
                </div>
                 
                <div className="d-flex">
                  {/* Notes */}
                  <div className="form-group col-sm-6">
                    <label htmlFor={"mainMediaKit"} className="mr-sm-2"><b>Notes</b></label>
                    <textarea
                      type="text"
                      id="mainMediaKit"
                      className="form-control"
                      maxLength="1000"
                      rows="4"
                      name="mainMediaKit"
                      value={notes}
                      onChange={(e) => setNotes(e.target.value)}
                      placeholder="Enter Notes(maximum 1000 characters)"
                    />
                    {notesError
                      &&
                      <div className="col-sm-10 mb-2 text-danger">{notesError}</div>
                    }
                  </div>
                  {/* Release Notes */}
                  <div className="form-group col-sm-6">
                    <label htmlFor={"mainMediaKit"} className="mr-sm-2"><b> Release Notes</b></label>
                    <textarea
                      type="text"
                      id="mainMediaKit"
                      className="form-control"
                      maxLength="1000"
                      rows="4"
                      name="mainMediaKit"
                      value={releasenotes}
                      onChange={(e) => setReleaseNotes(e.target.value)}
                      placeholder="Enter Release Notes(maximum 1000 characters)"
                    />
                    {releaseNotesError
                      &&
                      <div className="col-sm-10 mb-2 text-danger">{releaseNotesError}</div>
                    }
                  </div>
                </div>
               
                <div className="col-sm-12">
                  <button type="reset"
                    onClick={resetForm}
                    className="btn btn-md btn-light btn-link submit-btn-inline mr-sm-2">
                    <i className="fa fa-refresh"></i> Reset</button>
                  <button
                    type="submit"
                    className="btn btn-md btn-dark submit-btn-inline"
                    onClick={isEditMode ? updateMappingById : addMapping}
                  >
                    {isEditMode ? "Update" : "Add"}
                  </button>
                </div>
              </form>
            </AccordionDetails>
          </Accordion>
        </div>
        <div className="1col-sm-8">
          <MaterialTable
            title="Extra Mappings"
            columns={[
              { title: "Combine Key", field: "his_combine_key" },
              { title: "VMware vSphere Version", field: "vmware_vsphere_version" },
              { title: "VMware vCenter", field: "vmware_vcenter" },
              { title: "VMware vSAN Version", field: "vmware_vsan_version" },
              { title: "VMware VCF Version", field: "vmware_vcf_version" },
              { title: "URL to VMware Interoperability", field: "url_to_vmware_interoperability", render: rowData => urlRenderer(rowData?.url_to_vmware_interoperability) },
              { title: "vSAN Type", field: "vsan_type" },
              { title: "Compute Node", field: "compute_node" },
              { title: "Management Node", field: "management_node" },
              { title: "Management Software Version", field: "management_software_version" },
              { title: "SATADOM Boot", field: "satadom_boot" },
              { title: "Local Disk Boot", field: "local_disk_boot" },
              { title: "Local Disk Boot - M.2", field: "local_disk_boot_m2" },
              { title: "Notes", field: "notes" },
              { title: "Release Notes", field: "release_notes" },
              { title: "FC Direct Attach Boot", field: "fc_direct_attach_boot" },
              { title: "SAN Boot", field: "san_boot" },
              { title: "Build Number", field: "build_number" },
            ]}
            data={mappingList}
            options={{
              headerStyle: {
                backgroundColor: "#e9ecef",
              },
              actionsColumnIndex: -1,
              selection: false,
              search: true,
              maxBodyHeight: 400
            }}

            localization={{
              header: {
                actions: "Actions",
              },
            }}
            actions={
              [
                (rowData) => ({
                  icon: "edit",
                  tooltip: !rowData.is_deleted && "Edit Record",
                  onClick: (e, data) => editMapping(data),
                  hidden: !rowData?.id || rowData.is_deleted // display action only if any valid item is present
                }),
                (rowData) => ({
                  icon: rowData.is_deleted ? "undo" : "delete",
                  tooltip: rowData.is_deleted ? "Undo Deleted Record" : "Delete Record",
                  onClick: (e, data) => rowData.is_deleted ? restoreMappingHandler(data) : deleteMappingHandler(data),
                  hidden: !rowData?.id // display action only if any valid item is present
                })
              ]}
          />
        </div>
      </div>
    </div>
  )
}

export default ManageHisExtra;